import { ApiClient } from './base/apiClient';
import type { ApiResponse } from '~/types/api/common/apiResponse';
import type { GetStationInfoResponse } from '~/types/api/station/getStationInfo';
import type {
  GetStationNoticeRequest,
  GetStationNoticeResponse,
} from '~/types/api/station/getStationNotice';
import type {
  GetTrainDelayRequest,
  GetTrainDelayResponse,
} from '~/types/api/station/getTrainDelay';
import type { GetTrainDelayByDocumentNoRequest, GetTrainDelayByDocumentNoResponse } from '~/types/api/station/getTrainDelayByDocumentNo';

const BASE_PATH = '/station';

/**
 * 駅情報に関するリポジトリ
 */
export class StationRepository {
  private apiClient: ApiClient;

  constructor(displayId: string) {
    this.apiClient = new ApiClient(displayId);
  }

  /**
   * [sp-api-401] 駅からのお知らせ取得API
   *
   * @param request リクエスト
   * @returns レスポンス
   */
  async getStationNotice(
    request: GetStationNoticeRequest,
  ): Promise<ApiResponse<GetStationNoticeResponse>> {
    const query = new URLSearchParams();
    query.append('stationCd', request.stationCd);
    query.append('stationSubCd', request.stationSubCd);
    if (request.category !== undefined) {
      query.append('category', request.category);
    }

    return await this.apiClient.get<GetStationNoticeResponse>(BASE_PATH + '/notice', query);
  }

  /**
   * [sp-api-402] 列車位置・遅延情報取得API
   *
   * @param request リクエスト
   * @returns レスポンス
   */
  async getTrainDelay(
    request: GetTrainDelayRequest,
  ): Promise<ApiResponse<GetTrainDelayResponse>> {
    const query = new URLSearchParams();
    query.append('stationCd', request.stationCd);
    query.append('stationSubCd', request.stationSubCd);
    query.append('date', request.date);
    if (request.trainNo !== undefined) {
      query.append('trainNo', request.trainNo);
    }

    return await this.apiClient.get<GetTrainDelayResponse>(BASE_PATH + '/delay', query);
  }

  /**
   * [sp-api-403] 列車位置・遅延情報取得_伝票番号検索API
   *
   * @param request リクエスト
   * @returns レスポンス
   */
  async getTrainDelayByDocumentNo(
    request: GetTrainDelayByDocumentNoRequest,
  ): Promise<ApiResponse<GetTrainDelayByDocumentNoResponse>> {
    const query = new URLSearchParams();
    query.append('documentNo', request.documentNo);

    return await this.apiClient.get<GetTrainDelayByDocumentNoResponse>(BASE_PATH + '/delay/document_no', query);
  }

  /**
   * [sp-api-601] 駅設定情報取得API
   *
   * @param request リクエスト
   * @returns レスポンス
   */
  async getStationInfo(): Promise<ApiResponse<GetStationInfoResponse>> {
    return await this.apiClient.get<GetStationInfoResponse>(BASE_PATH + '/info');
  }
}
